// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrivacyPolicy_privacy_policy__RtRrp {
  max-width: 1125px;
  padding: 20px;
  font-family: 'Calibri', sans-serif;
  text-align: justify;
}

.PrivacyPolicy_privacy_policy_header__skIj1 {
  font-size: 22px;
  font-weight: bold;
  padding: 20px 0px;
}

h1 {
  font-size: 11pt;
  font-weight: bold;
  margin-bottom: 10px;
}

p {
  font-size: 11pt !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/PrivacyPolicy/PrivacyPolicy.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".privacy_policy {\n  max-width: 1125px;\n  padding: 20px;\n  font-family: 'Calibri', sans-serif;\n  text-align: justify;\n}\n\n.privacy_policy_header {\n  font-size: 22px;\n  font-weight: bold;\n  padding: 20px 0px;\n}\n\nh1 {\n  font-size: 11pt;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\np {\n  font-size: 11pt !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"privacy_policy": `PrivacyPolicy_privacy_policy__RtRrp`,
	"privacy_policy_header": `PrivacyPolicy_privacy_policy_header__skIj1`
};
export default ___CSS_LOADER_EXPORT___;
